import gql from 'graphql-tag';

import metadataQuery from './metadataQuery';
import searchQuery from './searchQuery';
import linkingQuery from './linkingQuery';
import poiQuery from './poiQuery';
import pricesQuery from './pricesQuery';
import citiesQuery from './citiesQuery';

const QUERY_SEARCH = gql`
  query Search(
    $cityId: String!
    $filters: FiltersInput
    $locale: String
    $url: String
    $moveIn: String
    $moveOut: String,
    $limit: Int
  ) {
    isLogged
    ${metadataQuery}
    ${searchQuery}
    ${linkingQuery}
    ${poiQuery}
    ${pricesQuery}
    ${citiesQuery}
    areas(city: $cityId) {
      id
      name
    }
  }
`;

export const getSearchQuery = client => (
  cityId,
  filters,
  locale = 'en',
  moveIn,
  moveOut,
  url,
  limit
) =>
  client.query({
    errorPolicy: 'all',
    query: QUERY_SEARCH,
    variables: {
      cityId,
      filters,
      locale,
      url,
      moveIn,
      moveOut,
      limit
    }
  });

export default getSearchQuery;
